export { default as asyncComponent } from './AsyncComponent'


// WEBPACK FOOTER //
// ../../src/AsyncComponent/index.js